<div class="w-100 p-3 card-historics-spec">
    <!-- <div class="card-header d-flex justify-content-center align-items-center">
        <h4 class="card-title mb-0 text-secondary">{{device}}</h4>

    </div> -->
    <div class="card-body py-3">
        <div class="row">
            <div class="col-xl-8 d-flex justify-content-center">
                <div class="graph-historics-big">
                    <div class="chart chart-sm w-100 h-100">
                        <canvas id="chart-card-historics" class="w-100 h-100"></canvas>
                      </div>
                </div>
            </div>

            <div class="col-xl-4">
                <div class="card-actions mb-3">
                    <h4 class="text-light">Day</h4>
                    <div class="input-group">
                        <input type="date"
                               class="form-control"
                               name="date"
                               #dateInput
                               [value]="getDateInputValue()"
                               (change)="onDateInputChange($event)">
     
                    </div>
                </div>
                <div>
                    <h6 class="text-light">{{"totalOfTheDay" | translate}}</h6>
                    <h3 class=" text-end">{{(totalEvse+totalHome)/1000| number:'1.2-2'}} kWh</h3>
                </div>
                <div>
                    <h6 class="text-light">{{"totalEvse" | translate}}</h6>
                    <h3 class=" text-end"> {{totalEvse/1000| number:'1.2-2'}} kWh </h3>
                </div>
                <div>
                    <h6 class="text-light">{{"totalHome" | translate}}</h6>
                    <h3 class=" text-end"> {{totalHome/1000| number:'1.2-2'}} kWh </h3>
                </div>
                <div  *ngIf="price > 0" >
                    <h6 class="text-light">{{"cost" | translate}}</h6>
                    <h3 class=" text-end"> {{(totalEvse)/1000 * price | number:'1.2-2'}} {{ coin }} </h3>
                </div>
            </div>
        </div>
        <button type="button" class="btn ms-1 btn-secondary" (click)="changeDate(-1)">
          <i class="fas fa-arrow-left"></i>
        </button>
        <button type="button" class="btn ms-1 btn-secondary" (click)="changeDate(1)">
          <i class="fas fa-arrow-right"></i>
        </button>
    </div>
</div>
